// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"PartnerAdAccount-dropdownContainer-3MhLiX"};